<template>
  <div id="app">
    <ZuiHeader :active="active"></ZuiHeader>
  <router-view @update="update"></router-view>

  </div>
</template>
<script>
  import ZuiHeader from './Headerbox.vue'
  export default {
    components:{ZuiHeader},
    data(){
      return{
        active:''
      }
    },
    methods:{
      update(n){
        this.active = n
        console.log(n)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/App.vue